// Module Import
//---------------------------------
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import TypographyAtom from '../../atoms/typography/typography'
import ArrowIcon from '../../../assets/images/icon_simplified_arrow.svg'
import ButtonAtom from '../../atoms/buttons/buttons'
import {
  brandIvory,
  brandOrange,
  brandSlate,
  brandSoftOrange,
  brandSoftGrey,
} from '../../../assets/consts/color'
import { secondaryFont } from '../../../assets/consts/fonts'
import Loader from '../../atoms/loader/Loader'
import useStore from '../../../context/StoreContext'
import mailIcon from '../../../assets/images/mail_icon.svg'
import notifyIcon from '../../../assets/images/notify_icon.svg'
import cartIcon from '../../../assets/images/cart_icon.svg'
import cartIconCancel from '../../../assets/images/shopping-cart-cancel-icon.svg'
import arrowIcon from '../../../assets/images/arrow_white_icon.svg'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const AccordionWrapper = styled.div`
  /* background: ${brandIvory}; */
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

const AccordionHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 48px;
  justify-content: space-between;
  padding: 24px 16px;
  width: 100%;
  background: ${brandIvory};

  cursor: pointer;
  user-select: none;

  h5,
  h3 {
    font-family: 'Poppins';
    font-weight: 400;
    line-height: 120%;
    color: ${brandSlate};
    margin: 0;
  }

  /* &:hover {
    color: ${brandOrange};
    background-color: ${brandSoftOrange};
    border-color: transparent;
  } */
`

const AccordionBody = styled.div`
  display: grid;
  gap: 8px;
`

const Icon = styled.div`
  height: 24px;
  width: 24px;

  display: grid;
  place-content: center;

  transition: all 0.1s ease-in-out;
  ${({ opened }) =>
    opened
      ? `
        transform: rotate(0);
    `
      : `transform: rotate(-90deg);`}

  img {
    width: 12px;
    height: 9px;
  }
`

const closed = {
  display: 'none',
}

const open = {
  display: 'block',
}

const ProductList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const ProductWrapper = styled.div`
  display: flex;
  align-content: center;
  /* justify-content: space-between; */
  flex-direction: row;
  gap: 8px;
`

const ProductImage = styled.img`
  width: 60px;
  max-width: 60px;
  padding: 0;

  object-fit: contain;

  @media (min-width: 768px) {
    width: 100px;
    max-width: 100px;
  }
`

const ProductInformation = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-start;
  flex-grow: 1;
  padding: 16px;
  min-width: 105px;

  width: clamp(100px, 100%, 500px);
  background: ${brandIvory};
`

const ProductTitle = styled.p`
  margin: 0;
  text-align: start;
`

const ProductLink = styled.a`
  width: 100%;
  text-decoration: none;
  border-bottom: none;
  font-weight: normal;

  font-size: 16px;

  color: ${brandSoftGrey};
  font-family: ${secondaryFont};
  line-height: 120%;
  //opacity: 75%;

  &:visited {
    color: ${brandSoftGrey};
  }

  &:hover {
    color: ${brandOrange};
    opacity: 1;
  }

  @media (min-width: 768px) {
    font-size: clamp(19px, 1vw, 24px);
  }
`

const ProductPrice = styled.p`
  margin: 0;
  padding: 0;
  flex: 0 0 auto;

  font-size: 12px;
  text-align: start;

  span {
    color: ${brandOrange};
  }

  @media (min-width: 768px) {
    font-size: 14px;
  }
`

const ProductButton = styled.p`
  position: relative;
  margin: 0;
  padding: 16px;

  //width: 200px;
  flex-shrink: 0;
  align-content: center;
  background: ${brandIvory};

  @media (max-width: 768px) {
    //width: 130px;
  }

  button,
  a {
    cursor: pointer;
    width: 200px;
    height: 56px;
    text-align: center;
    //display: grid;
    //place-content: center;
    line-height: 1.15;

    @media (max-width: 768px) {
      &:hover {
        background-color: ${brandOrange};
      }
    }

    &:active:hover {
      background-color: ${brandSoftOrange};
    }

    @media screen and (min-width: 48em) {
      img {
        display: none;
      }
      span {
        display: block !important;
      }
    }

    img {
      height: 20px;
      object-fit: contain;
      width: 20px;
    }

    span {
      display: none;
    }

    /* &:focus:hover {
      background-color: ${brandSoftOrange};
    } */

    /* width: 100%; */
    @media (max-width: 768px) {
      width: 32px !important;
      min-width: 32px;
      height: 32px;
      display: grid;
      place-content: center;
      text-wrap: wrap;
      padding: 0 !important;

      &:after {
        display: none;
      }
    }
  }

  button:disabled {
    opacity: 0.5;
    cursor: auto;

    user-select: none;
    pointer-events: none;
  }

  ${({ disabled }) =>
    disabled &&
    `
        user-select: none;

        button:disabled {
          cursor: auto;
          background-color: ${brandSoftOrange};
        }
        
         button:after {
          display: none;
        }
        
        button:active:hover {
          background: ${brandSoftOrange};
        }
        
    `}
`

function ItemButton({
  productData,
  isEnquireNow,
  isLoading,
  onAction,
  onEnquireNowOpen,
  isLearnMoreLabelOnly,
}) {
  const [isProductAdded, setIsProductAdded] = useState(false)
  const [cartItemId, setCartItemId] = useState('')
  const [buttonCopy, setButtonCopy] = useState(<Loader />)
  const { removeLineItem, cartItems, loading } = useStore()

  const isLearnMoreLabel = ['heliguy-essential-support'].includes(productData.handle)

  const handleEnquireNowOpen = () => onEnquireNowOpen(true)

  const handleClick = (product) => {
    if (cartItemId) {
      removeLineItem(cartItemId)
      setCartItemId('')

      return
    }

    onAction(product)
  }

  useEffect(() => {
    const cartLineId = cartItems.find(
      ({ product }) => product.id === productData?.variants?.nodes[0]?.id
    )?.product?.cartLineId

    if (cartLineId) {
      setCartItemId(cartLineId)
      setIsProductAdded(true)

      return
    }

    setIsProductAdded(false)
  }, [cartItems])

  useEffect(() => {
    if (isLoading || loading) {
      setButtonCopy(<Loader />)
    } else if (isEnquireNow) {
      if (isLearnMoreLabel) {
        setButtonCopy(isProductAdded ? 'Added to cart' : 'Learn more')
      } else {
        setButtonCopy('Enquire Now')
      }
    } else if (isLearnMoreLabelOnly) {
      setButtonCopy('Learn more')
    } else {
      setButtonCopy(isProductAdded ? 'Remove from cart' : 'Add to cart')
    }
  }, [isLoading, isProductAdded, loading])

  if (isEnquireNow && isLearnMoreLabel) {
    return isProductAdded ? (
      <ButtonAtom
        buttonCopy={
          <>
            <span>{buttonCopy}</span>
            <img src={arrowIcon} alt={'icon'} />
          </>
        }
        buttonType="Primary Button"
        disabled
      />
    ) : (
      <ButtonAtom
        href={`/products/${productData.handle}`}
        buttonCopy={
          <>
            <span>{buttonCopy}</span>
            <img src={arrowIcon} alt={'icon'} />
          </>
        }
        buttonType="Contained Button Outer Link"
        disabled={isLoading || loading}
        target="_blank"
      />
    )
  }

  if (isEnquireNow && !isLearnMoreLabel) {
    return (
      <ButtonAtom
        buttonCopy={
          <>
            <span>{buttonCopy}</span>
            <img src={mailIcon} alt={'icon'} />
          </>
        }
        buttonType="Primary Button"
        onClick={handleEnquireNowOpen}
      />
    )
  }

  if (isLearnMoreLabelOnly) {
    return (
      <ButtonAtom
        href={`/products/${productData.handle}`}
        buttonCopy={
          <>
            <span>{buttonCopy}</span>
            <img src={arrowIcon} alt={'icon'} />
          </>
        }
        buttonType="Contained Button Outer Link"
        disabled={isLoading || loading}
        target="_blank"
      />
    )
  }

  if (productData.totalInventory < 1) {
    return (
      <ButtonAtom
        href={`/products/${productData.handle}`}
        buttonCopy={
          <>
            <span>Notify me</span>
            <img src={notifyIcon} alt={'icon'} />
          </>
        }
        buttonType="Contained Button Outer Link"
        disabled={isLoading || loading}
        target="_blank"
      />
    )
  }

  return (
    <ButtonAtom
      buttonCopy={
        <>
          <span>{buttonCopy}</span>
          <img src={isProductAdded ? cartIconCancel : cartIcon} alt={'icon'} />
        </>
      }
      buttonType="Primary Button"
      disabled={isLoading || loading}
      onClick={() => {
        handleClick(productData)
      }}
    />
  )
}

// Component Export
//---------------------------------
export default function AccordionRelatedProducts({
  header,
  products,
  isOpenOnMount,
  onAction,
  onEnquireNowOpen,
  isLoading,
}) {
  const [accordionStatus, setaccordionStatus] = useState(isOpenOnMount)

  const isProductFree = (handle) =>
    [
      'heliguy-essential-support',
      'heliguy-advanced-support',
      'dji-terra-licence-for-m4t',
      'dji-terra-licence-for-m4e',
    ].includes(handle)

  const isEnquireNow = (handle) =>
    ['heliguy-advanced-support', 'heliguy-essential-support'].includes(handle)

  const isPriceOnRequest = (handle) => ['heliguy-advanced-support'].includes(handle)

  const isLearnMoreLabel = (handle) =>
    ['dji-terra-licence-for-m4t', 'dji-terra-licence-for-m4e'].includes(handle)

  const getPrice = (product) => {
    const productPriceOnRequest = isPriceOnRequest(product.handle)

    if (productPriceOnRequest) return 'Price on request'

    const productFree = isProductFree(product.handle)

    if (productFree) return 'Free'

    return Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
    }).format(product.priceRange?.maxVariantPrice?.amount)
  }

  // TODO: remove hardcode
  const isDiscountProduct = (handle) => ['a2-cofc-drone-training-course'].includes(handle)

  const openAccordion = () => {
    setaccordionStatus(!accordionStatus)
  }

  return (
    <AccordionWrapper>
      <AccordionHeader
        onClick={() => {
          openAccordion()
        }}
      >
        <TypographyAtom as="h3" type="H5" copy={header} weight="Bold" />
        <Icon opened={accordionStatus}>
          <img src={ArrowIcon} alt="" />
        </Icon>
      </AccordionHeader>
      <AccordionBody style={!accordionStatus ? closed : open}>
        <ProductList>
          {products.map((product) => (
            <ProductWrapper key={product.handle}>
              <ProductImage
                src={product?.featuredImage?.url}
                alt={product?.featuredImage?.altText}
              />
              <ProductInformation>
                <ProductTitle>
                  <ProductLink href={`/products/${product.handle}`} target="_blank">
                    {product.title}
                  </ProductLink>
                </ProductTitle>

                <ProductPrice>
                  <span>{getPrice(product)}</span>
                  {isDiscountProduct(product.handle) && (<span> (30% off when purchased with the drone)</span>)}
                </ProductPrice>
              </ProductInformation>
              <ProductButton disabled={isLoading}>
                <ItemButton
                  isLearnMoreLabelOnly={isLearnMoreLabel(product.handle)}
                  productData={product}
                  isEnquireNow={isEnquireNow(product.handle)}
                  isLoading={isLoading}
                  onAction={onAction}
                  onEnquireNowOpen={onEnquireNowOpen}
                />
              </ProductButton>
            </ProductWrapper>
          ))}
        </ProductList>
      </AccordionBody>
    </AccordionWrapper>
  )
}
